<section class="recipe-landing-skeleton-container">
  <div class="main-container">
    <ion-row
      class="desktop-tablet-print"
      *ngIf="platform !== platformRef.mobile"
    >
      <ion-col size="1" offset="10"
        ><ion-skeleton-text class="item squish" animated></ion-skeleton-text
      ></ion-col>
      <ion-col offset="0.25" size="0.75"
        ><ion-skeleton-text class="item squish" animated></ion-skeleton-text
      ></ion-col>
    </ion-row>

    <ion-row
      class="desktop-tablet-search"
      *ngIf="platform !== platformRef.mobile"
    >
      <ion-col size="4"
        ><ion-skeleton-text class="item squish" animated></ion-skeleton-text
      ></ion-col>
      <ion-col offset="5" size="1">
        <ion-skeleton-text class="item squish" animated></ion-skeleton-text>
      </ion-col>
      <ion-col size="1.5" offset="0.25"
        ><ion-skeleton-text class="item squish" animated></ion-skeleton-text
      ></ion-col>
    </ion-row>

    <ion-row
      class="desktop-tablet-search"
      *ngIf="platform !== platformRef.mobile"
    >
      <ion-col
        data-cy="recipe-card-checkbox-column"
        class="recipe-selector"
        [size]="platform === platformRef.desktop ? 0.6 : 0.8"
      >
        <ion-skeleton-text class="item squish" animated></ion-skeleton-text>
      </ion-col>
      <ion-col class="recipe" [size]="1" offset="1.2">
        <ion-skeleton-text class="item squish" animated></ion-skeleton-text>
      </ion-col>
      <ion-col
        class="group"
        [size]="platform === platformRef.desktop ? 1 : 1.25"
        [offset]="platform === platformRef.desktop ? 1 : 1.25"
      >
        <ion-skeleton-text class="item squish" animated></ion-skeleton-text>
      </ion-col>
      <ion-col
        *ngIf="platform !== platformRef.tablet"
        class="yield"
        [size]="1"
        offset="0.2"
      >
      </ion-col>
      <ion-col
        class="serving"
        [size]="platform === platformRef.desktop ? 1 : 1.15"
        offset="0.2"
      >
        <ion-skeleton-text class="item squish" animated></ion-skeleton-text>
      </ion-col>
      <ion-col
        class="serving-size"
        [size]="platform === platformRef.desktop ? 1 : 1.25"
        offset="0.2"
      >
        <ion-skeleton-text
          *ngIf="platform === platformRef.desktop"
          class="item squish"
          animated
        ></ion-skeleton-text>
      </ion-col>
      <ion-col class="cost-per-recipe" [size]="1" offset="0.2">
        <ion-skeleton-text class="item squish" animated></ion-skeleton-text>
      </ion-col>
      <ion-col class="cost-per-serving" [size]="1" offset="0.2">
        <ion-skeleton-text class="item squish" animated></ion-skeleton-text>
      </ion-col>
      <ion-col class="ellipsis" [size]="0.5" offset="0.3">
        <ion-skeleton-text class="item squish" animated></ion-skeleton-text>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="platform === platformRef.mobile">
      <ion-col size="12">
        <ion-skeleton-text class="item squish" animated></ion-skeleton-text>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="platform === platformRef.mobile">
      <ion-col size="5.25">
        <ion-skeleton-text class="item squish" animated></ion-skeleton-text>
      </ion-col>
      <ion-col size="2" offset="0.25">
        <ion-skeleton-text class="item squish" animated></ion-skeleton-text>
      </ion-col>
      <ion-col size="2" offset="0.25">
        <ion-skeleton-text class="item squish" animated></ion-skeleton-text>
      </ion-col>
      <ion-col size="2" offset="0.25">
        <ion-skeleton-text class="item squish" animated></ion-skeleton-text>
      </ion-col>
    </ion-row>

    <ion-skeleton-text class="item" animated></ion-skeleton-text>
    <ion-skeleton-text class="item" animated></ion-skeleton-text>
    <ion-skeleton-text class="item" animated></ion-skeleton-text>
    <ion-skeleton-text class="item" animated></ion-skeleton-text>
    <ion-skeleton-text class="item" animated></ion-skeleton-text>
    <ion-skeleton-text class="item" animated></ion-skeleton-text>
    <ion-skeleton-text class="item" animated></ion-skeleton-text>
    <ion-skeleton-text class="item" animated></ion-skeleton-text>
    <ion-skeleton-text class="item" animated></ion-skeleton-text>
  </div>
</section>
